import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, CssBaseline, Toolbar } from "@mui/material";
// import Sidebar from "../../sidebar/Sidebar";
import { Sidebar } from "components/index";
import SrgLinesList from "./SrgLinesList";
// import SrgLinesFilter from "./SrgLinesFilter";
// import AssetsManagerSuccessPrompt from "./AssetsManagerSuccessPrompt";
// import AssetsManagerErrorPrompt from "./AssetsManagerErrorPrompt";
// import AssetsManagerInfoPrompt from "./AssetsManagerInfoPrompt";
import { TypographyXLarge, TypographyNormal } from "components/customComponent";
import SrgLinesSuccessPrompt from "./SrgLinesSuccessPrompt";
import SrgLinesErrorPrompt from "./SrgLinesErrorPrompt";
import SrgLinesFontSizeSelect from "./SrgLinesFontSizeSelect";

const SrgLines = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("srgLines");

  const { user, features } = useSelector((state) => state.auth);
  const permission = user?.permission;

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    if (features?.["SMRT_SRG"] === false) {
      navigate("/");
      return;
    }

    if (permission && !permission.smrtLine?.read) {
      navigate("/");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, features]);

  if (!features?.enabled) {
    return (
      <div style={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 1 }}></Box>
      </div>
    );
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <Toolbar />
        <CssBaseline />

        <Container maxWidth="xl">
          <Box sx={{ mb: 1 }}>
            <TypographyXLarge sx={{ fontWeight: 700 }}>
              {t("title")}
            </TypographyXLarge>
            <TypographyNormal sx={{ fontWeight: 400 }}>
              {t("titleExplain")}
            </TypographyNormal>
          </Box>

          <SrgLinesSuccessPrompt />
          <SrgLinesErrorPrompt />

          <Box sx={{ my: 2 }}>
            {/* <SrgLinesFilter /> */}
            <Box display={"flex"}>
              <SrgLinesFontSizeSelect />
            </Box>
            <SrgLinesList permission={permission?.smrtLine} />
          </Box>
        </Container>
      </Box>
    </div>
  );
};

export default SrgLines;
